import { z } from 'zod';
/** ИИ аналитик (агент zeus на ноутбуке) — контракт портала.
 *  Спека: zeus-analytics docs/superpowers/specs/2026-10-09-portal-assistant-design.md */
export const AI_MAX_QUESTION = 2000;
export const AiAskRequest = z.object({
    question: z.string().trim().min(1).max(AI_MAX_QUESTION),
    branchId: z.number().int().positive().optional(),
});
export const AiChoiceRequest = z.union([
    z.object({ index: z.number().int().min(0).max(5) }).strict(),
    z.object({ text: z.string().trim().min(1).max(500) }).strict(),
    z.object({}).strict(),
]);
//# sourceMappingURL=ai.js.map